import { createSlice } from "@reduxjs/toolkit";
import { verifyCustomApiLookup } from "./api";

const initialState = {
  response: {},
  loading: false,
  error: null,
};

const verifyCustomApiLookupSlice = createSlice({
  name: "verifyCustomApiLookup",
  initialState,

  reducers: {
    clearVerifyBvnResponse: () => initialState,
  },

  extraReducers: (builder) => {
    builder.addCase(verifyCustomApiLookup.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(verifyCustomApiLookup.fulfilled, (state, action) => {
      state.response = action.payload;
      state.loading = false;
    });

    builder.addCase(verifyCustomApiLookup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { clearVerifyBvnResponse } = verifyCustomApiLookupSlice.actions;

export default verifyCustomApiLookupSlice.reducer;
